import { render } from "./detail_middle.vue?vue&type=template&id=4ead8772&scoped=true"
import script from "./detail_middle.vue?vue&type=script&lang=js"
export * from "./detail_middle.vue?vue&type=script&lang=js"

import "./detail_middle.vue?vue&type=style&index=0&id=4ead8772&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ead8772"]])

export default __exports__